module.exports = __webpack_public_path__ + "img/signpost-split.89acfbb3.svg";